export const WORKSPACE_ROOT_FOLDER_ID = -1;

export const FOLDERS_QUERY_NAME = 'FOLDERS_QUERY';
